// extracted by mini-css-extract-plugin
module.exports = {"cards":"card-module--cards--32CwQ"};